import { render, staticRenderFns } from "./yijia.vue?vue&type=template&id=17b0c961&scoped=true&"
var script = {}
import style0 from "./yijia.vue?vue&type=style&index=0&id=17b0c961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0c961",
  null
  
)

export default component.exports